import React, { useEffect, useState } from "react";
import { Select } from "antd";
import { ServicesGroupsDataType } from "../../interfaces/admin.interface";
import { ServicesGroupsService } from "../../services/services_group.service";

interface GroupNamesSelectProps {
  setFieldValue: (field: string, value: any) => void;
  group_name_id: number | null;
  selectedName: string | undefined;
  setSelectedName: (value: string | undefined) => void;
}

const SelectServicesGroupName: React.FC<GroupNamesSelectProps> = ({
  setFieldValue,
  group_name_id,
  selectedName,
  setSelectedName,
}) => {
  const [groupNames, setGroupNames] = useState<ServicesGroupsDataType[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    setLoading(true);
    ServicesGroupsService.getAllGroups()
      .then((response) => {
        setGroupNames(response?.data?.data);
        if (group_name_id === null) {
          setSelectedName(undefined);
        } else {
          const selectedGroupName = response?.data?.data.find(
            (element: ServicesGroupsDataType) =>
              element.id.toString() === group_name_id?.toString()
          );
          setSelectedName(selectedGroupName?.name || undefined);
        }
      })
      .finally(() => setLoading(false));
  }, [group_name_id, setSelectedName]);

  return (
    <Select
      style={{ width: "100%", height: "46px" }}
      placeholder={loading ? "Qrup adları yüklənir..." : "Qrup adı seçin"}
      options={groupNames?.map((element) => ({
        label: element.name,
        value: element.name,
      }))}
      value={selectedName}
      onChange={(newName) => {
        setSelectedName(newName);
        const selectedGroupName = groupNames.find(
          (element) => element.name === newName
        );
        if (selectedGroupName) {
          setFieldValue("service_group_id", selectedGroupName.id);
        }
      }}
    />
  );
};

export default SelectServicesGroupName;
